/**
 * @generated SignedSource<<3c96288c24580639cf8c7eba75c62918>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompetitionAutocompleteFragmentPaginationQuery$variables = {
  count?: number | null | undefined;
  search?: string | null | undefined;
};
export type CompetitionAutocompleteFragmentPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CompetitionAutocompleteFragment">;
};
export type CompetitionAutocompleteFragmentPaginationQuery = {
  response: CompetitionAutocompleteFragmentPaginationQuery$data;
  variables: CompetitionAutocompleteFragmentPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 10,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompetitionAutocompleteFragmentPaginationQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          (v1/*:: as any*/)
        ],
        "kind": "FragmentSpread",
        "name": "CompetitionAutocompleteFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "CompetitionAutocompleteFragmentPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              (v1/*:: as any*/)
            ],
            "kind": "ObjectValue",
            "name": "filters"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
          }
        ],
        "concreteType": "CompetitionConnection",
        "kind": "LinkedField",
        "name": "competitions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CompetitionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Competition",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "008f9cad5ffa5f4dcfab5af000650d70",
    "id": null,
    "metadata": {},
    "name": "CompetitionAutocompleteFragmentPaginationQuery",
    "operationKind": "query",
    "text": "query CompetitionAutocompleteFragmentPaginationQuery(\n  $count: Int = 10\n  $search: String\n) {\n  ...CompetitionAutocompleteFragment_3DeKgW\n}\n\nfragment CompetitionAutocompleteFragment_3DeKgW on Query {\n  competitions(first: $count, filters: {search: $search}) {\n    edges {\n      node {\n        id\n        title\n        slug\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "68e387c7c363993b63d9d3f1ce46c7d0";

export default node;
